export default __webpack_public_path__ + "static/media/ru.84f9a94c.svg";